import Spacing from '@components/Spacing';

interface BrandPhoto {
    _id?: string;
    url: string;
}

interface BrandPhotosPreviewProps {
    photos?: BrandPhoto[];
    visible: boolean;
}

const BrandPhotosPreview = ({ photos = [], visible }: BrandPhotosPreviewProps) => {

    if (!visible || photos.length === 0) {
        return null;
    }

    return (
        <Spacing vertical={1}>
            {photos.map((photo) => (
                <img
                    key={photo._id}
                    src={photo.url}
                    alt="Brand visual"
                    style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: 8,
                    }}
                />
            ))}
        </Spacing>
    );
};

export default BrandPhotosPreview;
